import React from "react";
import { Redirect } from "react-router-dom";
import { parse } from "query-string";
import jwtDecode from "jwt-decode";
import isEmpty from "lodash/isEmpty";
import { useSelector, useDispatch } from "react-redux";
import {
  receiveAccessToken,
  receiveIdToken,
  receiveProfileData,
} from "./actions/login";
import { Loader } from "./Components/Utils/Loader";

const AuthPage = ({ location }) => {
  const profile = useSelector((state) => state.profileReducer);
  const dispatch = useDispatch();

  if (isEmpty(profile)) {
    const hash = location.hash;
    const response = parse(hash);
    if (response.error) {
      alert(response.error_description);
      return <Redirect to="/FaultReporter/admin/customerfacilityfault" />;
    } else {
      dispatch(receiveProfileData(jwtDecode(response.id_token)));
      dispatch(receiveAccessToken(response.access_token));
      dispatch(receiveIdToken(response.id_token));
    }
    return <Loader />;
  } else {
    return <Redirect to={'/FaultReporter/admin/customerfacilityfault'} />;
  }
};

export default AuthPage;
